export default {
  code: "Mã nhân viên",
  name: "Tên nhân viên",
  org: "Phòng ban",
  gender: "Giới tính",
  dob: "Ngày sinh",
  inactive: "Ngừng theo dõi",
  salary: "Lương",
  QuickSearch: {
    Title: "Tìm nhân viên",
  },
  List: {
    Title: "Danh sách nhân viên",
    AddBtn: "Thêm",
    SearchEmptyText: "Nhập mã, tên nhân viên"
  },
  detail: {
    asset_code: "Mã tài sản",
    asset_name: "Tên tài sản",
    quantity: "Số lượng",
    unit: "Đơn vị",
    is_error: 'Đã hỏng'
  },

  period: "Khoảng thời gian",
  from: "Từ",
  to: "Đến",
  created: "Ngày lập",
  refdate: "Ngày HT",
  description: "Mô tả",
  refno: "Số CT"
};
